export const KEY = {
  enter: 'Enter'
}

export const FIRST_PAGE: { take: number, skip: number } = {
  take: 10,
  skip: 0
}